import { CaretRight } from '@phosphor-icons/react';

export default CaretRight;
